import React from 'react';
import { GET_COMPLETED_SENT_REFERRALS } from '../gql';
import { REFERRAL_REFRESH_SUBSCRIPTION } from '../../referral/gql/Subscription';
import { Stack } from '@mui/material';
import { IconDeviceLandlinePhone } from '@tabler/icons';
import DateTimeUtils from '../../common/services/DateTimeUtils';
import { referralIsOrderColumnItem } from '../tables/CommonReferralTable';
import CompletedReferrals from './common/CompletedReferrals';
import { MyTypography } from '../../common/components';
import ActiveReferralActionsCell from '../tables/components/ActiveReferralActionsCell';

const columns = [
  {
    field: 'patient',
    headerName: 'Patient Name',
    width: 180,
    valueGetter: params => {
      return params.row.referral.getFullName();
    },
  },
  {
    field: 'mrn',
    headerName: 'MRN',
    width: 150,
    valueGetter: params => {
      return params.row.referral.getMrn();
    },
  },
  {
    field: 'dob',
    headerName: 'Date of Birth',
    width: 150,
    valueGetter: params => {
      return params.row.referral.getPatientDob();
    },
  },
  {
    field: 'diagnosis',
    headerName: 'Diagnosis',
    width: 180,
    valueGetter: params => {
      return params.row.referral.getDiagnosis();
    },
  },
  {
    field: 'receiver',
    headerName: 'Referral Receiver',
    width: 320,
    valueGetter: params => {
      const clinic = params.row.receiver?.name || '';
      const provider = params.row.provider?.display_name || '';
      if (!clinic && !provider) return '';
      return `Clinic: ${clinic || 'N/A'} | Provider: ${provider || 'N/A'}`;
    },
    renderCell: params => {
      const clinic = params.row.receiver?.name || '';
      const provider = params.row.provider?.display_name || '';
      return (
        <Stack direction="row" spacing={1} alignItems="center">
          {(params.row.receiver?.clinic_users_count === 0 && params.row.is_fax) ? <IconDeviceLandlinePhone /> : null}
          <Stack direction="column" spacing={0.3}>
            <MyTypography variant="subtitle1" component="p" color="text.primary" style={{ margin: 0 }}>
              Clinic: {clinic || 'N/A'}
            </MyTypography>
            <MyTypography variant="subtitle1" component="p" color="text.primary" style={{ margin: 0 }}>
              Provider: {provider || 'N/A'}
            </MyTypography>
          </Stack>
        </Stack>
      );
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 150,
    headerAlign: 'center',
    sortable: false,
    editable: false,
    filterable: false,
    disableColumnMenu: true,
    align: 'center',
    renderCell: (params) => <ActiveReferralActionsCell row={params.row} completed={true}/>
  },
  {
    field: 'appointment_maintained',
    headerName: 'Maintained Appointment',
    width: 200,
    valueGetter: params => {
      return params.row.referral.isMaintainedAppointment();
    },
    renderCell: (params) => (
      <div style={{
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
      }} title={params.value}>
        {params.value}
      </div>
    ),
  },
  {
    field: 'appointments',
    headerName: 'Appointment Date',
    width: 200,
    valueGetter: params => {
      return params.row.referral.getDateOrReason();
    },
  },
  {
    field: 'sent_at',
    headerName: 'Date Sent',
    width: 250,
    valueGetter: params => {
      return params.row.referral.sentFormattedDate();
    },
    sortComparator: DateTimeUtils.dateSortComparator
  },
  referralIsOrderColumnItem,
  {
    field: 'updated_by',
    headerName: 'Last Updated By',
    width: 250,
    valueGetter: params => {
      return params.row.referral.getLastUpdatedByFullName();
    },
  },
  {
    field: 'updated_at',
    headerName: 'Last Updated At',
    width: 250,
    valueGetter: params => {
      return params.row.referral.formattedDate();
    },
    sortComparator: DateTimeUtils.dateSortComparator
  },
];

export default function CompletedSentReferrals({ uuid, onViewLogs, onView }) {
  return (
    <CompletedReferrals
      query={GET_COMPLETED_SENT_REFERRALS}
      uuid={uuid}
      subscription={REFERRAL_REFRESH_SUBSCRIPTION}
      onViewLogs={onViewLogs}
      onView={onView}
      columns={columns}
    />
  );
}
